import { render, staticRenderFns } from "./InputOfReserveContactSituationUserInfo.vue?vue&type=template&id=fa1b23ac&"
import script from "./InputOfReserveContactSituationUserInfo.vue?vue&type=script&lang=ts&"
export * from "./InputOfReserveContactSituationUserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InputOfReserveContactSituationUserInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports